/**
 * InspectionSchema model translations
 *
 * Translation keys follow the pattern: models.inspection-schema.{category}.{key}
 * Categories: fields, tabs, blocks, badges, filters
 */
export default {
  en: {
    singular: "Inspection Schema",
    plural: "Inspection Schemas",

    tabs: {
      general: "General",
      app_data: "Custom Data",
    },

    blocks: {
      identity: "Schema Details",
      template: "Template",
      custom_data: "App-Specific Data",
    },

    fields: {
      business_type: "Business Type",
      is_default: "Default",
      template: "Template",
      app_data: "App Data",
      created_at: "Created At",
      updated_at: "Updated At",
    },

    badges: {
      true: "Yes",
      false: "No",
    },

    filters: {
      business_type: "Business Type",
      is_default: "Default Only",
    },
  },

  fr: {
    singular: "Schéma d'inspection",
    plural: "Schémas d'inspection",

    tabs: {
      general: "Général",
      app_data: "Données personnalisées",
    },

    blocks: {
      identity: "Détails du schéma",
      template: "Modèle",
      custom_data: "Données spécifiques",
    },

    fields: {
      business_type: "Type d'entreprise",
      is_default: "Par défaut",
      template: "Modèle",
      app_data: "Données d'application",
      created_at: "Créé le",
      updated_at: "Modifié le",
    },

    badges: {
      true: "Oui",
      false: "Non",
    },

    filters: {
      business_type: "Type d'entreprise",
      is_default: "Par défaut uniquement",
    },
  },
};
